<template>
    <section v-if="isVisible" v-show="isAvailable" class="main-page-platform">
        <div class="a-container">
            <s-main-page-tag v-bind="tag({name: 'title'})" />
            <div v-if="content.list" class="list">
                <div
                    v-for="(item, itemIndex) in content.list"
                    :key="`item-${itemIndex}`"
                    :class="className(item) "
                >
                    <template v-if="item.info">
                        <div
                            v-for="(info, infoIndex) in item.info"
                            :key="`links-${infoIndex}`"
                            class="item"
                        >
                            <p v-if="info.title" class="title" v-html="info.title" />
                            <ul>
                                <li v-for="(link, linkIndex) in info.links" :key="`link-${linkIndex}`">
                                    <a-link v-bind="link" />
                                </li>
                            </ul>
                        </div>
                    </template>
                    <template v-else>
                        <a-picture v-if="item.picture" v-bind="item.picture" />
                        <div class="wrapper-button">
                            <a-button
                                v-if="isDesktop && item.button"
                                v-modal="'acronis-demo-modal'"
                                v-bind="item.button"
                                :to="null"
                                :title="item.button?.text"
                                @click="logInteraction()"
                            />
                            <a-button
                                v-else-if="item.button && !isDesktop"
                                v-bind="item.button"
                            />
                        </div>
                    </template>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import AButton from '@core/components/button/button.vue';
import ALink from '@core/components/link/link.vue';
import APicture from '@core/components/picture/picture.vue';
import Modal from '@core/directives/modal.js';
import breakpoint from '@core/mixins/breakpoint.js';
import mixin from '../components/mixin.js';
import SMainPageTag from '../components/tag.vue';

export default {
    name: 'SMainPagePlatform',
    components: {
        AButton,
        ALink,
        APicture,
        SMainPageTag,
    },
    directives: {
        Modal,
    },
    mixins: [mixin, breakpoint],
    props: {
        content: {
            type: Object,
            default: null,
        },
    },
    computed: {
        isVisible() {
            return this.content.title || this.content.list?.length;
        },
    },
    methods: {
        className(item) {
            return ['wrapper', { picture: item.picture }, { info: item.info }];
        },
        logInteraction() {
            if (!this.isDesktop) return;
            const demoButtonClickDate = localStorage.getItem('demoButtonClickDate');
            if (!demoButtonClickDate) {
                localStorage.setItem('demoButtonClickDate', new Date());
            }
        },
    },
};
</script>

<style lang="postcss" scoped>
.main-page-platform {
    padding: 32px 0 0;
    position: relative;
    .title {
        @mixin hero-accent;
        text-align: center;
        color: var(--av-nav-primary);
        @media (--viewport-desktop) {
            @mixin colls 6;
            margin: 0 auto;
        }
        @media (--viewport-desktop-wide) {
            @mixin colls 8;
        }
        @media (--viewport-desktop-large) {
            width: 100%;
        }
    }
    .list {
        gap: 16px;
        display: flex;
        margin-top: 24px;
        flex-direction: column;
        @media (--viewport-desktop-wide) {
            margin-top: 40px;
            flex-direction: row;
        }
    }
    .wrapper {
        gap: 48px;
        display: flex;
        text-align: center;
        flex-direction: column;
        @media (--viewport-tablet) {
            gap: 24px;
        }
        .item {
            @media (--viewport-tablet) {
                width: 40%;
            }
            @media (--viewport-desktop-wide) {
                height: 50%;
                width: 100%;
            }
        }
        .title {
            @mixin title-accent;
            margin: 0;
            width: auto;
            color: var(--av-nav-primary);
        }
        &:deep(.a-link) {
            display: flex;
            margin-top: 8px;
            justify-content: center;
            .a-link__content {
                line-height: 20px;
            }
        }
    }
    .wrapper-button {
        top: 0;
        width: 100%;
        height: 100%;
        display: flex;
        position: absolute;
        align-items: center;
        inset-inline-start: 0;
    }
    .info {
        @media (--viewport-tablet) {
            flex-direction: row;
            justify-content: center;
        }
        @media (--viewport-desktop-wide) {
            gap: 48px;
            flex: 1 1 0;
            flex-direction: column;
        }
        &:first-child {
            .title {
                @media (--viewport-desktop-wide) {
                    text-align: end;
                }
            }
            &:deep(.a-link) {
                @media (--viewport-desktop-wide) {
                    text-align: end;
                    justify-content: flex-end;
                }
                @media (--viewport-desktop-large) {
                    padding-inline-start: 64px;
                }
            }
        }
        &:last-child {
            .title {
                @media (--viewport-desktop-wide) {
                    text-align: start;
                }
            }
            &:deep(.a-link) {
                @media (--viewport-desktop-wide) {
                    text-align: start;
                    justify-content: flex-start;
                }
                @media (--viewport-desktop-large) {
                     padding-inline-end: 64px;
                }
            }
        }
    }
    .picture {
        min-height: 192px;
        &:deep(.a-picture) {
            width: 100%;
            height: auto;
            margin: auto;
            overflow: hidden;
            max-width: 762px;
            border-radius: 6px;
            border: 1px solid rgba(0, 0, 0, 0.05);
            box-shadow: 0 24px 54px 0 rgba(45, 48, 57, 0.09), 0 0.755px 1.585px 0 rgba(45, 48, 57, 0.03);
            .a-picture__img {
                width: 100%;
                height: 100%;
                position: relative;
            }
        }
        &:deep(.a-button) {
            margin: auto;
            min-width: 200px;
        }
    }
}
</style>
